import { sha256 } from 'js-sha256';
import { hzPortalVerConst } from './constants';
import { getPortalSignatureSecretKey } from './portalSignature.config';
import uuid from './uuid';

// HMAC 签名仅用于短信和会员接口，不改变其他接口独立使用的签名协议。
export const PORTAL_SIGNATURE_OPERATION = {
  SMS: 'sms',
  MEMBER: 'member',
};

// 优先使用安全随机源，旧浏览器不支持或调用异常时降级为项目 UUID（去掉连字符）。
const createNonce = () => {
  try {
    if (window.crypto && typeof window.crypto.getRandomValues === 'function') {
      const bytes = new Uint8Array(16);
      window.crypto.getRandomValues(bytes);
      return Array.from(bytes, (value) => ('0' + value.toString(16)).slice(-2)).join('');
    }
  } catch (error) {
    // 部分定制 WebView 暴露了 API 但实际不可用，保持请求兼容，不记录敏感上下文。
  }
  // 该降级沿用项目的 Math.random 实现，仅用于 nonce 去重，不具备密码学不可预测性。
  return uuid().replace(/-/g, '');
};

// 签名字段与实际传参保持一致，不对手机号做数值转换、编码或隐式裁剪。
const getRequiredValue = (value) => {
  if ((typeof value !== 'string' && typeof value !== 'number') || !String(value).trim()) {
    throw new Error('门户安全签名参数不完整');
  }
  return String(value);
};

// 每次请求重新生成 HMAC sign，替代这两个接口原有的 MD5 sign。
export const createPortalSignature = ({ operation, hzPortalVer, countryCode, hotelId, mobile }) => {
  if (operation !== PORTAL_SIGNATURE_OPERATION.SMS && operation !== PORTAL_SIGNATURE_OPERATION.MEMBER) {
    throw new Error('不支持的门户安全签名场景');
  }

  const country = getRequiredValue(countryCode);
  const phone = getRequiredValue(mobile);
  const hotel = operation === PORTAL_SIGNATURE_OPERATION.SMS && hzPortalVer === hzPortalVerConst.V24 ?
    getRequiredValue(hotelId) : '';
  const secretKey = getPortalSignatureSecretKey();
  const timestamp = Date.now();
  const nonce = createNonce();
  const rawString = country + hotel + phone + timestamp + nonce;

  return {
    // 使用 sign 字段发送完整 64 位小写十六进制 HMAC。
    sign: sha256.hmac(secretKey, rawString),
    timestamp,
    nonce,
  };
};
